import { toast } from 'sonner';
import type { UploadOutcome } from '@/shared/hooks/useUploadQueue';

/**
 * Eine Meldung für den ganzen Stapel statt einer je Bild. Den Grund einer gescheiterten Datei
 * meldet deren Upload selbst; hier steht, was ankam und was über die Grenze ging.
 */
export function toastUploadOutcome(outcome: UploadOutcome, limitHint: string) {
  if (outcome.uploaded > 0) {
    toast.success(
      outcome.uploaded === 1 ? '1 Bild hinzugefügt' : `${outcome.uploaded} Bilder hinzugefügt`,
    );
  }
  if (outcome.skipped > 0) toast.error(skippedText(outcome.skipped, limitHint));
}

export function skippedText(skipped: number, limitHint: string): string {
  return `${limitHint} — ${skipped === 1 ? '1 Bild wurde' : `${skipped} Bilder wurden`} nicht übernommen.`;
}
